import { render, staticRenderFns } from "./alertActivation.vue?vue&type=template&id=2345d71a&"
import script from "./alertActivation.vue?vue&type=script&lang=js&"
export * from "./alertActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports